import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import * as featureActions from '../../index';
import {StatusService} from '../../../services/status.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';

@Injectable()
export class StatusLogEffects {
  private actions$ = inject(Actions);
  private statusService = inject(StatusService);
  private store$ = inject(Store<fromStore.State>);

  constructor() {}
  readStatusLogs$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.StatusLogActionTypes.GetStatusLogs),
    map((action: featureActions.GetStatusLogs) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      if (isNaN(payload.dcode)) {
        return of(new featureActions.GetStatusLogsFail());
      }
        // NgRx 9 不可變性: 創建新對象副本
        const params = { ...payload, otp: user.otp };
        return this.statusService.ReadDeviceStatusLog(params).pipe(
          map((res: any) => {
              if (res.result) {
                const body = (Object.keys(res.msg.body).length === 0) ? [] : res.msg.body;
                return new featureActions.LoadStatusLogs(body);
              } else {
                return new featureActions.GetStatusLogsFail();
              }
            }
        ),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
          catchError(error => of(new featureActions.GetStatusLogsFail()))
        );
    })
  ));

}